import React, {useState} from 'react';
import {type PlanType} from 'api/generated';

import {type PayDurationType} from './Plans.Toggle.PayDuration';
import PlansTableDesktop from './Plans.Table.Desktop';
import PlansTableMobile from './Plans.Table.Mobile';

interface IPlansTableProps {
  plans: PlanType[];
  currentPlan: PlanType;
  onSubscribe: (plan: PlanType) => void;
}

const PlansTable = ({plans, currentPlan, onSubscribe}: IPlansTableProps) => {
  const [payDuration, setPayDuration] = useState<PayDurationType>('monthly');
  return (
    <div className="py-2">
      <PlansTableDesktop
        payDuration={payDuration}
        setPayDuration={setPayDuration}
        plans={plans}
        currentPlan={currentPlan}
        onSubscribe={onSubscribe}
      />
      <PlansTableMobile payDuration={payDuration} setPayDuration={setPayDuration} plans={plans} currentPlan={currentPlan} onSubscribe={onSubscribe} />
    </div>
  );
};

export default React.memo(PlansTable);
